import { writable, get } from 'svelte/store';
import { apiClient } from '$lib/api/client';

/** One register event a search can select on. */
export interface SignalKind {
  slug: string;
  label: string;
  means?: string;
  /** Whether it takes a least amount (CHF): the capital increase. */
  takes_min_amount?: boolean;
}

export interface SignalCatalogue {
  signals: SignalKind[];
  days: number[];
  default_days: number;
}

export const signalCatalogue = writable<SignalCatalogue | null>(null);
export const signalCatalogueFailed = writable<boolean>(false);

let inFlight: Promise<void> | null = null;

/** Fetches the signals once per page load, from the server that runs the query. */
export async function loadSignalCatalogue(): Promise<void> {
  if (get(signalCatalogue) !== null) return;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const response = await apiClient.get<SignalCatalogue>('/filters/signals');
      signalCatalogue.set(response.data);
      signalCatalogueFailed.set(false);
    } catch {
      signalCatalogueFailed.set(true);
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}

// In development, forget the catalogue on a hot reload, as the technology store does.
if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    signalCatalogue.set(null);
    signalCatalogueFailed.set(false);
  });
}
